export default {
  id: 104,
  title: 'Target #104 - Amegakure',
  url: 'https://cssbattle.dev/play/104',
  colors: ['#000000', '#37385A', '#9897AE', '#C0C3DB'],
  solution:
    '<a a><a b><a c><a d><style>[c],[d]{top:125;width:10;background:#000;border-radius:9in}body{background:#000}a{position:fixed}[a]{top:90;left:80;width:240;height:120;background:#37385a;border-radius:20px}[b]{top:110;left:100;width:200;height:80;background:linear-gradient(-75deg,#9897ae 0 38%,#c0c3db 38% 62%,#9897ae 62%);border-radius:10px}[c]{left:165;height:50;box-shadow:20px 0,40px 0,60px 0}[d]{left:115;height:10;box-shadow:0 20px,0 40px,160px 0,160px 20px,160px 40px}</style>',
}
